import { Button } from "@mui/material";
import {
  Input,
  MuiBox,
  MuiTypography,
  SubmitLoaderButton,
} from "components/atoms";
import { FormikProvider, useFormik } from "formik";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { closeCenterModal } from "store/slices/CenterModal.slice";
import * as Yup from "yup";
// import {
//   ChangePasswordAction,
//   SetSecondPasswordAction,
// } from "store/middlewares/settings/profile";
import { useTranslation } from "react-i18next";
import { CNewPassword, NPassword } from "utils/validation/CommonValidation";
import { ManageDrivePrefrenceAction } from "store/middlewares/profile";

const ChangePassword = ({ type = "new", SuccessFunction, onCancel }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [loader, setLoader] = useState(false);

  const handleSubmit = (values) => {
    setLoader(true);
    dispatch(
      ManageDrivePrefrenceAction({
        driveSecureEnabled: `true`,
        driveLockPassword: values?.newPassword,
        onError: () => {
          setLoader(false);
        },
        onSuccess: () => {
          dispatch(closeCenterModal());
          setLoader(false);
        },
      }),
    );
    SuccessFunction?.();
  };

  const formik = useFormik({
    initialValues: {
      newPassword: "",
      confirmPassword: "",
    },
    validationSchema: Yup.object({
      newPassword: NPassword(t),
      confirmPassword: CNewPassword(t),
    }),
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: handleSubmit,
  });

  return (
    <MuiBox component={"form"} onSubmit={formik.handleSubmit}>
      <FormikProvider value={formik}>
        <MuiBox
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "20px",
            p: "24px",
          }}
        >
          <MuiBox sx={{ display: "flex", flexDirection: "column" }}>
            <MuiTypography fontWeight="600" variant="20" color="text.darkBlack">
              {t(
                type === "new"
                  ? "modal.allPassword.setNewPassword"
                  : "setting.changePassword",
              )}
            </MuiTypography>
            <MuiTypography
              variant="14"
              fontWeight={"400"}
              sx={{ color: "text.lightgray", wordBreak: "break-word" }}
            >
              {t(
                type === "new"
                  ? "modal.allPassword.createPasswordProtectThisFileFolder"
                  : "modal.allPassword.setNewPasswordContinueDescr",
              )}
            </MuiTypography>
          </MuiBox>
          <MuiBox
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "16px",
            }}
          >
            <Input
              label={t("modal.allPassword.newPassword")}
              type="password"
              placeholder={t("modal.allPassword.enterNewPassword")}
              name={"newPassword"}
              value={formik.values.newPassword}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              errorMsg={formik.errors.newPassword}
              error={formik.touched.newPassword && formik.errors.newPassword}
              isBorderColor={true}
            />
            <Input
              label={t("modal.allPassword.confirmPassword")}
              type="password"
              placeholder={t("modal.allPassword.enterConfirmPassword")}
              name={"confirmPassword"}
              onChange={formik.handleChange}
              value={formik.values.confirmPassword}
              onBlur={formik.handleBlur}
              errorMsg={formik.errors.confirmPassword}
              error={
                formik.touched.confirmPassword && formik.errors.confirmPassword
              }
              isBorderColor={true}
            />
          </MuiBox>
        </MuiBox>
        <MuiBox
          sx={{
            display: "flex",
            gap: "12px",
            justifyContent: "end",
            backgroundColor: "background.gray200",
            p: "16px 24px",
          }}
        >
          <Button
            variant="whiteContained"
            onClick={() => {
              dispatch(closeCenterModal());
              onCancel?.();
            }}
          >
            {t("commonButton.cancel")}
          </Button>

          <SubmitLoaderButton
            variant="blueContained"
            btnText={t("modal.allPassword.confirm")}
            isDisable={loader}
            isLoading={loader}
            type="submit"
          />
        </MuiBox>
      </FormikProvider>
    </MuiBox>
  );
};

export default ChangePassword;
